import storageService from '../../services/storageService'
import {USER_CONFIG} from '../../config/UserConfig'

const clienteMutation = {
    ADD_CLIENTE_FORMULARIO:(state,payload) => {
        state.clienteFormulario = payload;
        //add cliente no localStorage
        storageService.setJsonItem(USER_CONFIG.clienteFormulario,payload);
    }
}

export default clienteMutation;


// WEBPACK FOOTER //
// ./src/store/mutations/cliente.mutation.js